/*
 *  Collection Carousel
 *    Scripts for the Collection Carousel section. Creates a slick slide for
 *    smaller devices.
 *
 *  Version:
 *    1.0.0 - 2019/04/17
 */

import { CarouselSection } from './../carousel/CarouselSection';
import { register } from './../ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';
import { initialiseWishlist } from './../../tools/Wishlist';

export const CONTAINER_SELECTOR = '[data-products-carousel-container]';
export const CAROUSEL_SELECTOR = '[data-products-carousel]';

export class ProductsCarousel extends CarouselSection {
  constructor(container) {
    super(container);
    this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    this.slick = this.initCarousel(this.carouselContainer);
     //wishlist
     $(document).on('window.swymPageLoad', initialiseWishlist());
  }

  optionOverrides() {
    return {
      arrows: true,
      responsive: [
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: { slidesToShow: 2, slidesToScroll: 1 }
        },
        {
          breakpoint: ResponsiveSizes.medium-1,
          settings: { slidesToShow: 2, slidesToScroll: 1, arrows: true }
        },
        {
          breakpoint: ResponsiveSizes.large-1,
          settings: { slidesToShow: 3, slidesToScroll: 1, arrows: true }
        },
        {
          breakpoint: ResponsiveSizes.xlarge-1,
          settings: { slidesToShow: 4, slidesToScroll: 1, arrows: true }
        },
        {
          breakpoint: ResponsiveSizes.xxlarge-1,
          settings: { slidesToShow: 5, slidesToScroll: 1, arrows: true }
        }
      ]
    }
  }
}

register(CONTAINER_SELECTOR, ProductsCarousel);
